import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const ReportingIcon = observer(
    'ReportingIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M16.333 2.333v7h7m-4.666 5.834-4.084 4.083-2.333-2.333-2.917 2.916m7.584-17.5H7a2.333 2.333 0 0 0-2.333 2.334v18.666A2.333 2.333 0 0 0 7 25.667h14a2.333 2.333 0 0 0 2.333-2.334V8.75l-6.416-6.417Z'
            />
        </SvgElement>
    )
);
